export const categories = [
    { slug: 'tecnologia', name: 'Tecnología' },
    { slug: 'hogar', name: 'Hogar' },
    { slug: 'belleza', name: 'Belleza' },
    { slug: 'moda', name: 'Moda' },
    { slug: 'viajes', name: 'Viajes' },
    { slug: 'supermercado', name: 'Supermercado' },
    { slug: 'mascotas', name: 'Mascotas' },
    { slug: 'segunda-mano', name: 'Segunda mano' },
    { slug: 'velas-y-bienestar', name: 'Velas y bienestar' },
    { slug: 'eventos', name: 'Eventos' },
    { slug: 'erotico-adultos', name: 'Erótico y adultos (+18)' },
    { slug: 'ocio-cultura', name: 'Libros, música y ocio' }
];

export const stores = [
    { slug: 'amazon', name: 'Amazon', category: 'tecnologia' },
    { slug: 'aliexpress', name: 'AliExpress', category: 'hogar' },
    { slug: 'banggood', name: 'Banggood', category: 'tecnologia' },
    { slug: 'pccomponentes', name: 'PcComponentes', category: 'tecnologia' },
    { slug: 'miravia', name: 'Miravia', category: 'hogar' },
    { slug: 'samsung', name: 'Samsung', category: 'tecnologia' },
    { slug: 'honor', name: 'Honor', category: 'tecnologia' },
    { slug: 'xiaomi', name: 'Xiaomi', category: 'tecnologia' },
    { slug: 'phone-house', name: 'Phone House', category: 'tecnologia' },
    { slug: 'fnac', name: 'Fnac', category: 'ocio-cultura' },
    { slug: 'electrodepot', name: 'Electrodepot', category: 'tecnologia' },
    { slug: 'orange', name: 'Orange', category: 'tecnologia' },
    { slug: 'targus', name: 'Targus', category: 'tecnologia' },
    { slug: 'mediawave-store', name: 'Mediawave store', category: 'tecnologia' },
    { slug: 'kaspersky', name: 'Kaspersky', category: 'tecnologia' },
    { slug: 'alexphone', name: 'Alexphone', category: 'tecnologia' },
    { slug: 'adidas', name: 'Adidas', category: 'moda' },
    { slug: 'joma', name: 'Joma', category: 'moda' },
    { slug: 'sneakin', name: 'Sneakin', category: 'moda' },
    { slug: 'voghion-global', name: 'Voghion Global', category: 'moda' },
    { slug: 'camperdays', name: 'Camperdays', category: 'viajes' },
    { slug: 'edreams', name: 'eDreams', category: 'viajes' },
    { slug: 'rumbo', name: 'Rumbo', category: 'viajes' },
    { slug: 'qatar-airways', name: 'Qatar Airways', category: 'viajes' },
    { slug: 'ita-airways-es', name: 'ITA Airways ES', category: 'viajes' },
    { slug: 'viajes-carrefour', name: 'Viajes Carrefour', category: 'viajes' },
    { slug: 'druni', name: 'Druni', category: 'belleza' },
    { slug: 'ok-farma', name: 'Ok Farma', category: 'belleza' },
    { slug: 'elifexir', name: 'Elifexir', category: 'belleza' },
    { slug: 'winged-essence', name: 'Winged Essence', category: 'belleza' },
    { slug: 'el-corte-ingles', name: 'El Corte Ingles', category: 'hogar' },
    { slug: 'conforama', name: 'Conforama', category: 'hogar' },
    { slug: 'banak', name: 'Banak', category: 'hogar' },
    { slug: 'aigostar', name: 'Aigostar', category: 'hogar' },
    { slug: 'ninja-kitchen', name: 'Ninja kitchen', category: 'hogar' },
    { slug: 'stihl', name: 'Stihl', category: 'hogar' },
    { slug: 'teletienda-directo', name: 'Teletienda Directo', category: 'hogar' },
    { slug: 'la-tienda-en-casa', name: 'La Tienda en Casa', category: 'hogar' },
    { slug: 'jarmino', name: 'Jarmino', category: 'supermercado' },
    { slug: '15bodegas', name: '15bodegas', category: 'supermercado' },
    { slug: 'zooplus', name: 'Zooplus', category: 'mascotas' },
    { slug: 'cash-converters', name: 'Cash Converters', category: 'segunda-mano' },
    { slug: 'entradas', name: 'Entradas', category: 'eventos' },
    { slug: 'see-tickets', name: 'See Tickets', category: 'eventos' },
    { slug: 'adsrunningshop', name: 'AdsRunningShop', category: 'hogar' },
    { slug: 'perfumeria-comas', name: 'Perfumería Comas', category: 'belleza' },
    { slug: 'deubaxxl', name: 'DeubaXXL', category: 'hogar' },
    { slug: 'acer', name: 'Acer', category: 'tecnologia' },
    { slug: 'saludonnet', name: 'Saludonnet', category: 'velas-y-bienestar' },
    { slug: 'hivital', name: 'HIVITAL', category: 'velas-y-bienestar' },
    { slug: 'diversual-es', name: 'Diversual ES', category: 'erotico-adultos' },
    { slug: 'lovense', name: 'Lovense', category: 'erotico-adultos' },
    { slug: 'bijoux-indiscrets', name: 'Bijoux Indiscrets', category: 'erotico-adultos' },
    { slug: 'easytoys', name: 'EasyToys', category: 'erotico-adultos' },
    { slug: '365rider', name: '365Rider', category: 'moda' },
    { slug: 'leroy-merlin', name: 'Leroy Merlin', category: 'hogar' },
    { slug: 'lampara', name: 'Lampara', category: 'hogar' },
    { slug: 'wakkap', name: 'Wakkap', category: 'ocio-cultura' },
    { slug: 'tirendo', name: 'Tirendo', category: 'hogar' },
    { slug: 'revolution-soft', name: 'Revolution Soft', category: 'tecnologia' },
    { slug: 'fundacionexcelentia-es', name: 'Fundacionexcelentia_ES', category: 'ocio-cultura' }
];

export const featuredStores = [
    stores.find((store) => store.slug === 'amazon'),
    stores.find((store) => store.slug === 'aliexpress'),
    stores.find((store) => store.slug === 'pccomponentes'),
    stores.find((store) => store.slug === 'miravia'),
    stores.find((store) => store.slug === 'el-corte-ingles'),
    stores.find((store) => store.slug === 'druni'),
    stores.find((store) => store.slug === 'adidas'),
    stores.find((store) => store.slug === 'xiaomi')
];

export function findCategory(slug) {
    return categories.find((category) => category.slug === slug);
}

export function findStore(slug) {
    const normalizedSlug = slugify(slug);
    const compactSlug = normalizedSlug.replace(/-/g, '');
    return stores.find((store) => {
        const storeSlug = slugify(store.slug);
        return storeSlug === normalizedSlug || storeSlug.replace(/-/g, '') === compactSlug;
    });
}

export function slugify(value) {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
